"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileStore = void 0;
var services_1 = require("../services");
var UserProfileStore = /** @class */ (function () {
    function UserProfileStore() {
    }
    UserProfileStore.prototype.get = function (userId) {
        var rest = services_1.Services.Department.rest;
        return rest.Department.User.getProfileById(userId).value;
    };
    return UserProfileStore;
}());
exports.UserProfileStore = UserProfileStore;
//# sourceMappingURL=user.profile.store.js.map